
import {
    SET_PROMPTS,
    SET_SYSTEM_PROMPTS,
} from './types';

import { apiCallV2, servicesAPICall } from "../../utils/api";

export const GetPrompts = (page, count, filter, sort, retrieveOnly = false) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "prompt/get-all",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: {
                type: "user",
                ...filter
            },
            sort: sort,
        },
    );

    if (retrieveOnly) {
        return res.data.prompts;
    } else {
        dispatch({
            type: SET_PROMPTS,
            data: {
                list: res.data.prompts,
                count: res.data.count[0]["count(*)"]
            }
        })
    }



}

export const GetSystemPrompts = () => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "prompt/get-all",
        "",
        localStorage.getItem("access-token"),
        {
            page: 1,
            limit: 1000,
            filters: { type: "system" },
            sort: null,
        },
    );

    dispatch({
        type: SET_SYSTEM_PROMPTS,
        data: {
            list: res.data.prompts,
            count: res.data.count[0]["count(*)"]
        }
    })

}


export const UpdatePrompt = (id, prompt) => async (dispatch, getState) => {
    const { list, count } = getState().Prompt;

    const res = await apiCallV2(
        "POST",
        "prompt/save",
        {
            id: id,
            prompt: prompt
        },
        localStorage.getItem("access-token"),
    );

    if (res.data?.data?.success) {
        dispatch({
            type: SET_PROMPTS,
            data: {
                list: list?.map((p) => {
                    if (p.id === id) {
                        return {
                            ...p,
                            prompt: prompt
                        }
                    }

                    return p;
                }),
                count: count
            }
        })

        return true;
    } else {
        return false;
    }

}

export const UpdatePromptV2 = (id, prompt, isSystemPrompt = false) => async (dispatch, getState) => {
    const { list, count, systemPrompts } = getState().Prompt;

    const res = await apiCallV2(
        "POST",
        "prompt/update",
        {
            id: id,
            promptDetails: prompt
        },
        localStorage.getItem("access-token"),
    );

    if (res.data?.data?.success) {

        if (isSystemPrompt) {

            dispatch({
                type: SET_SYSTEM_PROMPTS,
                data: {
                    list: systemPrompts?.map((p) => {
                        if (p.id === id) {
                            return {
                                ...p,
                                text: prompt.text,
                            }
                        }

                        return p;
                    }),
                    count: 0
                }
            })
        } else {
            dispatch({
                type: SET_PROMPTS,
                data: {
                    list: list?.map((p) => {
                        if (p.id === id) {
                            return {
                                ...p,
                                ...prompt
                            }
                        }

                        return p;
                    }),
                    count: count
                }
            })
        }
        return true;
    } else {
        return false;
    }

}


export const TestPrompt = (prompt) => async (dispatch) => {
    const res = await servicesAPICall(
        "POST",
        "prompt/test",
        {
            prompt: prompt
        },
        localStorage.getItem("access-token"),
    );

    if (res?.data?.data?.success) {
        return res?.data?.data;
    } else {
        return {
            success: false,
        }
    }

}

export const TestPromptV2 = (prompt, details, responseFormat = "") => async (dispatch) => {
    const res = await servicesAPICall(
        "POST",
        "prompt/test",
        {
            prompt: prompt,
            details: details,
            responseFormat: responseFormat,
        },
        localStorage.getItem("access-token"),
    );

    if (res?.data?.data?.success) {
        return res?.data?.data;
    } else {
        return {
            success: false,
        }
    }
}

export const AddPrompt = (promptDetails) => async (dispatch, getState) => {
    const { list, count } = getState().Prompt;

    const res = await apiCallV2(
        "POST",
        "prompt/add",
        {
            ...promptDetails
        },
        localStorage.getItem("access-token"),
    );

    if (res.data?.data?.success) {
        dispatch({
            type: SET_PROMPTS,
            data: {
                list: [{
                    ...promptDetails,
                    id: res.data.data.id,
                    createdAt: new Date(),
                }, ...list],
                count: count
            }
        })

        return true;
    } else {
        return false;
    }

}